<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        จัดการผู้ใช้งาน (Users)
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-user"></i> จัดการผู้ใช้งาน (Users)
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="100px"
                      :model="form"
                    >
                      <div class="col-sm-6">
                        <el-form-item label="อีเมล" prop="text">
                          <el-input v-model="form.text" placeholder="example@mail.com" clearable></el-input>
                        </el-form-item>
                      </div>
                      <div class="col-sm-6">
                        <el-form-item label="เบอร์โทรศัพท์" prop="phone">
                          <el-input
                            placeholder="090xxxxxxx"
                            v-model="form.phone"
                            maxlength="10"
                            show-word-limit
                            clearable
                            @keypress.native="isNumberKey"
                          ></el-input>
                        </el-form-item>
                      </div>
                      <div class="col-sm-6">
                        <el-form-item label="สถานะ">
                          <el-checkbox-group v-model="form.status">
                            <el-checkbox label="Active"></el-checkbox>
                            <el-checkbox label="Inactive"></el-checkbox>
                          </el-checkbox-group>
                        </el-form-item>
                      </div>
                      <div class="col-sm-12">
                        <div class="layout_filter_btn">
                          <button type="button" @click="searching()" class="btn btn-primary">ค้นหา</button>
                        </div>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <div class="box-body">
                  <data-tables-server
                   @query-change="searching"
                    :data="tabledata"
                    :total="total"
                    :page-size="10"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                    :table-props="tableProps"
                  >
                    <el-table-column prop="namePic" label="รูปภาพ" width="100">
                      <template slot-scope="scope">
                        <div class="img-radius">
                          <img :src="scope.row.profile_image" >
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column sortable prop="phone_number" label="เบอร์โทรศัพท์" width="150" ></el-table-column>
                    <el-table-column sortable prop="email" label="อีเมล" width="170"></el-table-column>
                    <el-table-column sortable prop="brand_name_th" label="เครือข่าย" width="100"></el-table-column>
                    <el-table-column sortable="custom" prop="created_at" label="วันที่ลงทะเบียนเริ่มใช้งาน" width="150"></el-table-column>
                    <el-table-column sortable="custom" prop="latest_login" label="วันและเวลาที่เข้าใช้งานล่าสุด" style="min-width:190px"></el-table-column>
                    <el-table-column sortable prop="status" label="สถานะ" width="100"></el-table-column>
                    <el-table-column label="จัดการ" align="center" width="120" fixed="right">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="ดูข้อมูล" placement="top">
                          <el-button
                            size="mini"
                            type="success"
                            @click="handleView(scope.row)"
                          >
                            <i class="el-icon-view"></i>
                          </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="ลบ" placement="top">
                          <el-button
                            :disabled="scope.row.status == 'Inactive'"
                            v-if="delete_u"
                            class="custom-btn"
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.row)">
                            <i class="el-icon-delete-solid"></i>
                          </el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                  <UserInfo :data="diagloData" :dialog="dialog" @checkModal="closeModal"></UserInfo>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import UserInfo from "../Modal/Modal_user_details";
export default {
  components: {
    UserInfo: UserInfo
  },
  data() {
    return {
      diagloData: {},
      dialog: false,
      label_position: "top",
      data_dialog: null,
      dialogVisible: false,
      tableProps: {
        border: true
      },
      form: { 
        text: "", 
        phone: "", 
        status: ["Active"],
        page: 1, 
        pageSize: 10 ,
        sort : {
          order : null,
          prop : null
        }
      },
      data: []
    };
  },
  mounted(){
    const permission = JSON.parse(atob(this.$cookies.get("user_nbtc").permission)).Manage_user; 
    this.delete_u = permission.includes('delete') ?   true :false ;
  },
  computed: {
    ...mapState({
      tabledata: store => store.Manage_user.tabledata,
      total: store => store.Manage_user.total,
      loading : store => store.Manage_user.loading
    })
  },
  methods: {
    ...mapActions({
      search_user: "Manage_user/search_user",
      delete_user: "Manage_user/delete_user"
    }),
    searching(queryInfo) {
      let formdata = Object.assign(this.form,queryInfo)
      this.search_user(formdata)
    },
    handleClose(done) {
      done();
    },
    handleView(data) {
      this.diagloData = data;
      this.dialog = true;
    },
    closeModal(value) {
      this.dialog = value;
    },
    handleDelete(info) {
      this.$confirm("ลบผู้ใช้งาน", "แจ้งเตือน", {
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        type: "warning"
      })
      .then(() => {
        this.delete_user(info.user_id).then(() => {
          this.searching()
        })
      })
      .catch(() => {});
    }
  }
}
</script>
<style>
.new-space-user{
  padding-top:16px;
}
.set-box-center-user{
margin-top: 0px;
}

</style>
